import { jsx as _jsx } from "react/jsx-runtime";
import { CheckCircleFilled } from "@ant-design/icons";
import { observer } from "mobx-react";
import { AffiliateStatePanel } from "./affiliateStatePanel.js";
import { __, _i } from "../../../../../../utils/i18n.js";
import { MATOMO_MASK } from "../../../../../../utils/matomoMask.js";
const AffiliateSignupSuccessState = observer(({ variant, email })=>{
    const heading = variant === "double-opt-in" ? __("Check your inbox to activate your affiliate account") : __("Your application is in");
    const body = variant === "double-opt-in" ? _i(__("We sent you a link to {{email}}%s{{/email}}. Click it to finish setting up your affiliate account.", email ?? ""), {
        email: /*#__PURE__*/ _jsx("span", {
            ...MATOMO_MASK
        })
    }) : __("We'll review it within three business days and let you know by email.");
    return /*#__PURE__*/ _jsx(AffiliateStatePanel, {
        tone: "success",
        icon: /*#__PURE__*/ _jsx(CheckCircleFilled, {}),
        heading: heading,
        children: body
    });
});
export { AffiliateSignupSuccessState };
